import { Typography } from 'fitify-ui-landing/src/components/Typography/Typography'
import type { PropsWithChildren } from 'react'

import { StyledSection } from '@/components/exercises/Exercise/Section/Section.Styled'

type Props = PropsWithChildren<{
  title: string
}>

export const Section = ({ children, title }: Props) => {
  return (
    <StyledSection>
      <Typography
        as="h2"
        $variant="Headline/H 24"
        $variantPhone="Headline/H 20"
      >
        {title}
      </Typography>
      {children}
    </StyledSection>
  )
}
